import utils from '@/utils';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getGroups: param => {
		let queryStr = utils.objectToQueryString({
			useYn: 'Y'
		});
		return client
			.get(`${BASE_URL}/userGroup/v1/plants/${param.plantCd}/groups` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getMenus: param => {
		let queryStr = '';
		if (param.msgLang !== undefined) {
			queryStr = utils.objectToQueryString({
				msgLang: param.msgLang,
				useYn: 'Y'
			});
		}
		return client
			.get(`${BASE_URL}/menu/v1/plants/${param.plantCd}/screens` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},

	getScreens: ({ plantCd, langCd }) => {
		return client
			.get(`${BASE_URL}/menu/v1/plants/${plantCd}/languages/${langCd}/screens`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	getGroupScreenFuncList: param => {
		console.warn('DBGDBG ===> param', param);
		let queryStr = '';
		if (param.groupId !== undefined) {
			queryStr = utils.objectToQueryString({
				groupId: param.groupId
			});
		}
		return client
			.get(`${BASE_URL}/menu/v1/plants/${param.plantCd}/screens/${param.screenId}/roles` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getCommFuncList: param => {
		let queryStr = utils.objectToQueryString({});
		return client
			.get(`${BASE_URL}/menu/v1/plants/${param.plantCd}/funcList` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	postGroupScreenFuncList: param => {
		return client
			.post(`${BASE_URL}/menu/v1/status/${param.status}/plants/${param.plantCd}/screens/${param.screenId}/roles`, param.data)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	postGroupCopy: param => {
		return client
			.post(`${BASE_URL}/menu/v1/status/1/plants/${param.plantCd}/roleCopy`, param)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
